import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useReservation } from '../context';
import { FormContent } from '../components/ReservationForm/FormContent';
import { reservationValidationSchema } from '../validations/reservationValidationSchema';
import { initialValues } from '../constants/reservationConstants';
import { useAuth } from '../../auth';

export default function ReservationFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { createReservation, updateReservation, reservationData, isDataLoading } = useReservation();
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const isEditing = Boolean(id);

  const getInitialValues = () => {
    if (isEditing && reservationData) {
      return {
        name: reservationData.name || '',
        start_date: reservationData.startDate || '',
        end_date: reservationData.endDate || '',
        room_id: reservationData.roomId || '',
        tenant_id: reservationData.tenantId || '',
        user_id: reservationData.userId || '',
      };
    }
    return initialValues;
  };

  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      if (isEditing && id) {
        await updateReservation(id, values);
      } else {
        values.tenant_id = auth.selectedTenant;
        await createReservation(values);
      }
      navigate('/reservations');
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (isEditing && isDataLoading) {
    return (
      <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}>
        Carregando dados da reserva...
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Formik
        initialValues={getInitialValues()}
        validationSchema={reservationValidationSchema}
        enableReinitialize={true}
        onSubmit={handleSubmit}
      >
        {(formikProps) => {
          console.log('Formik errors:', formikProps.errors);
          console.log('Formik values:', formikProps.values);
          
          return (
            <Form>
              <FormContent
                values={formikProps.values}
                errors={formikProps.errors}
                touched={formikProps.touched}
                isSubmitting={loading || formikProps.isSubmitting}
                setFieldValue={formikProps.setFieldValue}
                onSubmit={formikProps.handleSubmit as any}
              />
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
}